exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu {\n  display: flex;\n  justify-content: flex-end;\n  position: relative;\n  top: -8px;\n  right: 16px;\n}\n", ""]);

// exports
